import {CATEGORY, generic} from '../edap';
import {GENERIC_EVENT, trigger} from '../../utils/edap';

export const clickedControl = (label) => {
    trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_CREATE_CONTROL_CLICK,
        eventcategory: CATEGORY,
        eventlabel: label
    });
};

export const modalSeen = () => {
    trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_CREATE_MODAL_SEEN,
        eventcategory: CATEGORY
    });
};

export const modalClosed = () => {
    trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_CREATE_MODAL_CLOSED,
        eventcategory: CATEGORY
    });
};

export const modalError = () => {
    trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_CREATE_MODAL_ERRORED,
        eventcategory: CATEGORY
    });
};


export default {
    clickedControl,
    modalClosed,
    modalSeen,
    modalError
};



// WEBPACK FOOTER //
// ./src/universal/tripboard/create-tripboard-controls/edap.js